import { createRicosFunctionalExtension } from './create-ricos-extension';
import * as setNodeAlignment from './node-commands/setNodeAlignment';
import * as setNodeSize from './node-commands/setNodeSize';
import * as toggleNodeTextWrap from './node-commands/toggleNodeTextWrap';

export const commonNodeCommands = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'ricos-common-node-commands',
  createExtensionConfig() {
    return {
      name: this.name,
      addCommands() {
        return {
          ...setNodeSize,
          ...setNodeAlignment,
          ...toggleNodeTextWrap,
        };
      },
    };
  },
});
